export const TypeList = {
  WATCHED: 'watched',
  QUEUE: 'queue',
}
